<template>
  <el-card>
      <div slot="header">Configuration</div>
      <div>
        <div class="item">
          E-Soccer automatically create teams：
          <el-select v-model="config.electronicSoccerAutoCreateTeamDatasource" placeholder="Select" @change="save('electronicSoccerAutoCreateTeamDatasource')" clearable="" size="mini" >
           <el-option v-for="item in sourceList" :key="item.value" :value="item.value" :label="item.label"></el-option>
           <el-option label="Off" :value="0"></el-option>
          </el-select>
        </div>
        <br>
        <div class="item">
          E-Basketball automatically create teams：
          <el-select v-model="config.electronicBasketballAutoCreateTeamDatasource" placeholder="Select" @change="save('electronicBasketballAutoCreateTeamDatasource')"  clearable="" size="mini">
            <el-option v-for="item in sourceList" :key="item.value" :value="item.value" :label="item.label"></el-option>
            <el-option label="Off" :value="0"></el-option>
          </el-select>
        </div>
        <br>
        <div class="item" v-if="hasDeleteOutrightMongo">
          Delete SR Outright Mongo: 
          <el-input v-model="matchId" placeholder="Input matchId" size="mini" style="width: 200px; margin-left: 10px;"></el-input>
          <el-button type="danger" size="mini" @click="handleDeleteOutrightMongo" style="margin-left: 10px;">Delete</el-button>
        </div>
      </div>
  </el-card>
</template>

<script>
import { saveConfiguration, getConfiguration, removeOutrightMongo } from '@/service'
import { originData } from  '@/utils/constants'
import { mapGetters } from 'vuex'
export default {
  data()  {
    return {
      sourceList: originData,
      config: {},
      matchId: ''
    }
  },
  computed: {
    ...mapGetters(['functionInfoList']),
    hasDeleteOutrightMongo() {
      return this.functionInfoList.some((item) => {
        return (
          item.privilegeMark === 'TMC/Page/configuration/delete-sr-outright-mongo' &&
          item.featureStatus !== 3
        )
      })
    }
  },
  created() {
    this.getConfiguration()
  },
  methods: {
    getConfiguration()  {
      getConfiguration().then(res =>  {
        if(res.code === 0) {
          this.config = res.data
        }
      })
    },
    save(key) {
      saveConfiguration({[key]: this.config[key]}).then(res => {
        if(res.code === 0) {
          this.getConfiguration()
          this.$message.success('Success')
        }
      })
    },
    handleDeleteOutrightMongo() {
      if (!this.matchId) {
        this.$message.warning('Please input matchId')
        return
      }
      removeOutrightMongo(this.matchId).then(res => {
        if(res.code === 0) {
          this.$message.success('Delete success')
          this.matchId = ''
        } else {
          this.$message.error(res.message || 'Delete failed')
        }
      }).catch(err => {
        this.$message.error('Delete failed')
      })
    }
  }
}
</script>